<template>
    <div class="input-wrapper" :class="{'invalid-border': isInvalid}">
        <label class="font-6 truncate input">
            <span class="input-name truncate" :class="{'disabled': isDisable}">
                {{ label }}
            </span>
            <span class="input-separator"/>
            <div class="input-value truncate">
                <slot name="inputValue">
                    <input type="text"
                           ref="inputRef"
                           class="input-slot"
                           :placeholder="placeholder"
                           :value="value"
                           :id="uniqueId"
                           @click.stop
                           :maxlength="maxlength"
                           @focus="isFocus = true"
                           @blur="isFocus = false"
                           :class="{'font-6': boldOnFocusOut && !isFocus}"
                           @input="$emit('input', $event.target.value)"
                    >
                </slot>
            </div>
        </label>
        <slot name="inputIcon"/>
    </div>
</template>

<script>

export default {
    name: 'LabelInput',
    props: {
        placeholder: String,
        isDisable: Boolean,
        label: String,
        uniqueId: String,
        boldOnFocusOut: Boolean,
        maxlength: Number,
        isInvalid: Boolean,
        value: String
    },
    data() {
        return {
            isFocus: false
        };
    },
    methods: {
        focus() {
            this.$nextTick().then(() => {
                this.$refs.inputRef.focus();
            });
        }
    }
};
</script>
<style scoped lang="scss">
@import "~styles/styleGuide.scss";

.input-wrapper {
    padding: 6px 14px 8px 12px;
    border-radius: 4px;
    border: $border;
    background-color: $white;
    color: $dark-300;
    height: 32px;
    line-height: normal;
    display: inline-block;
    width: 100%;

    &:focus-within {
        border: solid 1px $primaryColor;
    }

    .disabled {
        cursor: default;
        color: $light-700;
    }

    &.invalid-border {
        border-color: $negative-200;
    }
}


.input {
    width: calc(100% - 8px);
    cursor: inherit;
}

.focus-class {
    border: solid 1px $primaryColor;
}


.input-separator {
    color: $light-400;
    height: 16px;
    margin-right: 4px;
    margin-top: -7px;
    vertical-align: middle;
    display: inline-block;
    border-left: $border;
}

.input-name {
    width: 35px;
    color: $light-800;
    margin: 0 7px 0 0;
    text-align: center;
    display: inline-block;
    position: static;
}

.input-value {
    overflow: hidden;
    margin-left: 3px;
    width: calc(100% - 55px);
}

input[type='text'].input-slot {
    width: 100%;
    height: 16px;
    display: inline-flex;
    color: $dark-300;
    transition: width 0.22s ease-out;

    &:focus {
        outline: none;
    }

    // override global css
    padding-left: 0;
    border: none;
}

.input-slot::placeholder {
    color: $light-800;
    @include font(7);
}

</style>
